import { Provider } from '@angular/core';

import { BhApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const LocalizationGrpcContractProvider: Provider = {
  provide: BhApi.LocalizationBhGrpcContractClient,
  useFactory: CommonGrpcContractFactory(BhApi.LocalizationBhGrpcContractClient),
};
